"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var WorksheetWordStore = /*#__PURE__*/function (_RootStore) {
  function WorksheetWordStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, WorksheetWordStore);
    _this = _callSuper(this, WorksheetWordStore);
    _this.config = {
      model: _models.WorksheetWord,
      deserialize: true,
      GET: {
        index: '/worksheets/:worksheetId/worksheet_words'
      },
      PUT: {
        update: 'worksheet_words/:worksheetWordId',
        createWordStructure: '/worksheet_words/:worksheetWordId/create_word_structure'
      },
      POST: {
        moveToUnprocessedVocab: '/worksheet_words/move_to_unprocessed_vocab'
      },
      DELETE: {
        destroy: '/worksheet_words/:worksheetWordId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(WorksheetWordStore, _RootStore);
  return (0, _createClass2["default"])(WorksheetWordStore, [{
    key: "moveToUnprocessedVocab",
    value: function moveToUnprocessedVocab(params, callback) {
      this.api(params, callback, 'POST', 'moveToUnprocessedVocab');
    }
  }, {
    key: "createWordStructure",
    value: function createWordStructure(params, callback) {
      this.api(params, callback, 'PUT', 'createWordStructure');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new WorksheetWordStore();